import Button from "@src/app/components/Button/Button";
import Link from "@src/app/components/Link";
import type { ReactElement } from "react";

interface Props {
  icon: ReactElement;
  label: string;
  iconOnly?: boolean;
  mediaType: string;
  onClick?: () => void;
}

export default function SocialShareButton({
  icon,
  label,
  iconOnly,
  mediaType,
  onClick,
}: Props): ReactElement {
  return (
    <Link
      to=""
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className={`a2a_button_${mediaType}`}
      aria-label={`Share on ${mediaType}`}
      onClick={onClick}
    >
      <Button
        variant={iconOnly ? "secondary" : "ghost"}
        size="medium"
        icon={icon}
        className="w-full"
      >
        {!iconOnly && <span>{label}</span>}
      </Button>
    </Link>
  );
}
